import React from 'react';
import { alpha, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from 'components/Container';

const Headline = ({
    label,
    variant = 'h4',
    align = 'center',
    gutterBottom = true,
    containerProps = {},
    typographyProps = {},
    sx = {},
}) => {
    const theme = useTheme();

    const Content = (
        <Box
            sx={{
                position: 'relative',
                '&::before': {
                    position: 'absolute',
                    content: '""',
                    width: '30%',
                    zIndex: 1,
                    top: 0,
                    left: 0,
                    height: '100%',
                    backgroundSize: '18px 18px',
                    backgroundImage: `radial-gradient(${alpha(
                        theme.palette.primary.dark,
                        0.4,
                    )} 20%, transparent 20%)`,
                    opacity: 0.2,
                },
                '&::after': {
                    position: 'absolute',
                    content: '""',
                    width: '30%',
                    zIndex: 1,
                    top: 0,
                    right: 0,
                    height: '100%',
                    backgroundSize: '18px 18px',
                    backgroundImage: `radial-gradient(${alpha(
                        theme.palette.primary.dark,
                        0.4,
                    )} 20%, transparent 20%)`,
                    opacity: 0.2,
                },
            }}
        >
            <Box position="relative" zIndex={2}>
                <Typography
                    variant={variant}
                    align={align}
                    gutterBottom={gutterBottom}
                    sx={{
                        fontWeight: 800,
                        letterSpacing: 0.5,
                        lineHeight: 1.25,
                        ...sx,
                    }}
                    {...typographyProps}
                >
                    <Box
                        component="span"
                        sx={{
                            display: 'block',
                            mt: 0.5,
                            color: 'text.primary',
                            textShadow: `0 2px 12px ${alpha(
                                theme.palette.primary.main,
                                0.35,
                            )}`,
                            fontWeight: 700,
                        }}
                    >
                        {label}
                    </Box>
                </Typography>
            </Box>
        </Box>
    );

    return <Container {...containerProps}>{Content}</Container>;
};

export default Headline;
